import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/i18n/translations";

export default function PaymentCancel() {
  const { t } = useLang();
  return (
    <div className="pt-40 pb-40 min-h-screen">
      <div className="max-w-lg mx-auto px-5 text-center card-dark rounded-2xl p-12" data-testid="payment-cancel-page">
        <XCircle className="w-16 h-16 text-crimson-accent mx-auto mb-6" />
        <h1 className="font-serif text-3xl mb-3">{t({ fr: "Paiement annulé", en: "Payment cancelled" })}</h1>
        <p className="text-cream/60 mb-8">{t({ fr: "Votre panier est conservé.", en: "Your cart is saved." })}</p>
        <Link to="/boutique" className="btn-gold rounded-full px-8 py-4">{t({ fr: "Retour à la boutique", en: "Back to shop" })}</Link>
      </div>
    </div>
  );
}
